<div>

  <br/>
  <br/>

  <!-- Logo -->
  <div class="section-logo">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
          <div class="text-center">
            <a routerLink="/"><picture>
              <source srcset="/images/login/logo.webp" type="image/webp">
              <img class="logo-top" height="22" src="/images/login/logo.png" alt="Croissant logo"/>
            </picture></a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Login -->
  <div class="section-login">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
          <div class="form-container">

            <!-- Title -->
            <div class="row">
              <div class="col">
                <h2>Welcome back!</h2>
              </div>
              <div class="col">
                <div class="text-end">
                  <a (click)="forgotPassword()" class="forgot-password-link" style="font-size:12px">Forgot password?</a>
                </div>
              </div>
            </div>

            <br/>

            <!-- Form -->
            <div class="row">
              <div class="col">
                <form (ngSubmit)="login()" ngNativeValidate>

                  <div class="input-group">
                    <span class="input-group-text"><label for="email"><i class="bi bi-envelope"></i></label></span>
                    <div class="form-floating">
                      <input id="email" type="email" name="email" [(ngModel)]="email" class="form-control" placeholder="Email" required>
                      <label for="email">Email</label>
                    </div>
                  </div>

                  <br/>

                  <div class="input-group">
                    <span class="input-group-text"><label for="password"><i class="bi bi-shield-lock"></i></label></span>
                    <div class="form-floating">
                      <input id="password" type="password" name="password" [(ngModel)]="password" class="form-control" placeholder="Password" minlength="6" required>
                      <label for="password">Password</label>
                    </div>
                  </div>

                  <br/>

                  <button type="submit" class="btn btn-login btn-lg btn-block" style="font-size: 18px; min-height: 40px;" [disabled]="loading">Log in</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br/>

  <!-- Signup -->
  <div class="section-signup">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="extra-padding">
            <div class="text-center">
            <p>
              <span class="not-member">Don't have an account?</span>&nbsp;
              <a class="link-info link-underline" routerLink="/join">Sign up now.</a>
            </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br/>
  <br/>
  <br/>
  <br/>

</div>
